

export default function getProducts(room, austattung_produkt){

    const productList = [];

    let fullCount = 0;

    if(
        room.selectedEquipment["melden_kontakt_fenster"] !== undefined
        && Boolean(room.selectedEquipment["melden_kontakt_fenster"])
        && austattung_produkt["binaereingang"] !== undefined
        && room.windowCount > 0
    ){
        fullCount += room.windowCount * room.doorCount;
    }
    if(
        room.selectedEquipment["melden_kontakt_tuer"] !== undefined
        && Boolean(room.selectedEquipment["melden_kontakt_tuer"])
        && austattung_produkt["binaereingang"] !== undefined
        && room.doorCount > 0
    ){
        fullCount+= room.doorCount;
    }
    if(
        room.selectedEquipment["melden_leckage"] !== undefined
        && Boolean(room.selectedEquipment["melden_leckage"])
        && austattung_produkt["binaereingang"] !== undefined
    ){
        fullCount++;
    }
    if(fullCount > 0){
        productList.push({
            product: austattung_produkt["binaereingang"],
            count: Math.ceil(fullCount / 6)
        })
    }

    return productList;
}
